
<script>

  import func from "../../libs/functions.js";
  //import { StripeCheckout } from 'vue-stripe'

  import {
    mapGetters,
    mapState,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import _system from '../../libs/system';

   import VueSlider from 'vue-slider-component'
   import 'vue-slider-component/theme/default.css'

   import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';
   import system from '../../libs/system';

   const StripeCheckout = window.StripeCheckout;

   window.plans = [];

   export default {
   name: "Upgrade",
   components: {
    VueSlider
  },
   data() {
      return {
         channelPlanQuantity:1,
         handler: {},
         purchases: [],
         allPurchases: [],
         total: {},
         StripeCheckout:StripeCheckout,
         loading: {
            open: false
         },
         isLtd: false,
         limitexceed: false,
         allActiveAccounts: '',
         totalLimits2: '',
         pricingInterval: 'year',
         socialChannelPrice: 7,
         teamMemberPrice: 15,
         teamMemberCount: 1,
         socialChannelCount: 1,
         upgraded: false,
         couponCode: '',
         couponPercentage: 0,
         couponObject: {},
         plans:{},
         features: {},
         activePeriod: 'an'
      }
   },
   computed: {
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('workspaceusers', ['workspaceusers']),
   ...mapGetters('accounts', ['accounts']),
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('subscriptions', ['getPaypalSubscriptions', 'getSubscriptions']),
   ...mapGetters('plans', ['getPlans']),
      trialChecker(){
      let diff = (Math.floor(Date.now()) - this.getUser.createdAt);
         if(this.currentWorkspace.pricingPlan == 'Trial' && diff >= 1209600000){
         setTimeout(() => {
               this.setUpgradeModal(true)
         }, 20000);
         return true
         }else{
            return false
         }
      },
      totalLimits(){
         this.total.price = this.amountCutter(_.sumBy(this.allPurchases, 'amount'));
         this.total.users = _.sumBy(this.allPurchases, 'userLimit');
         this.total.channels = _.sumBy(this.allPurchases, 'channelLimit');

         return this.total
      }
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("htmlModals", ["setUpgradeModal"]),
   ...mapActions('tags', ['setTags']),
   ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
   ...mapActions('workspaceusers', ['setWorkspaceusers']),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
      amountCutter(amount){
         if(amount.length > 3){
            return amount.toString().slice(0, amount.toString().length -2 )
         }else{
            return amount
         }
         
      },
      closeModal(){
         document.body.classList.remove('overflowYHidden');
         this.setUpgradeModal(false);
      },
      tryCoupon(){
         let payload = {
            query: {
               couponCode: this.couponCode
            }
         }
         _system.services.stripe.checkCoupon(payload, (err, couponObject) => {
            if(err) return iziToast.error({ title: 'Noooo! 😿' });

            iziToast.success({
               title: 'Yaaaaayyyy! 🎉'
            });

            this.plans['an'] = _.map(this.plans['an'], (plan) => {
               console.log(plan)
               plan.metadata.price = '$' + (plan.metadata.price.slice(1,-3) - (plan.metadata.price.slice(1,-3) * couponObject.percent_off / 100)) + '/mo'
               plan.amount = Math.floor((plan.amount - (plan.amount * couponObject.percent_off / 100)))
               return plan
            })

            this.plans['mo'] = _.map(this.plans['mo'], (plan) => {
               plan.metadata.price = '$' + (plan.metadata.price.slice(1,-3) - (plan.metadata.price.slice(1,-3) * couponObject.percent_off / 100)) + '/mo'
               plan.amount = Math.floor((plan.amount - (plan.amount * couponObject.percent_off / 100)))
               return plan
            })

            this.couponCode = ''
            this.couponObject = couponObject
         });
      },
      open(plan, quantity){
         //pk_test_ESdTL2pe5FB5ypsvZ0obEceO
         //pk_live_IVNhGZ7zbbZLFLHRDz4SMOL8
         this.loading.open = true;
         var token_triggered = false;
         this.handler = this.StripeCheckout.configure({ 
            key: 'pk_live_IVNhGZ7zbbZLFLHRDz4SMOL8',
            closed: () => {
               if (!token_triggered) {
                  // close button click behavior goes here
                  this.loading.open = false;
               } else {
                  // payment completion behavior goes here
                  this.upgraded = true
               }
            },
            token: (token) => {

               token_triggered = true;

                  let payload = {
                     body: {
                        tokenId : token.id
                     },
                     query: {
                        userId: this.getUser._id
                     }
                  }

                  _system.services.stripe.createCustomer(payload, (err, newCustomer) => {

                  payload = {
                     body: {
                        items: [{
                           price: plan.id,
                           quantity: quantity
                        }],
                        customer: this.getUser._id
                     }
                  }

                     if(this.couponObject.id) payload.body.couponId = this.couponObject.id;
                     _system.services.stripe.createSubscription(payload, (err, subscription) => {
                        if(err){
                           console.log(err)
                            return alert(err.data.message)
                        }
                        alert('Payment succeed, just refresh your browser and check your billing section to confirm your purchase.')
                     });

                  });

               } 
            });




         this.handler.open({
            name: 'Juphy, Inc.',
            description: plan.metadata.name,
            amount: plan.amount * quantity,
            email: this.getUser.email
         });


      },
      onlyActiveAccounts(){
         return _.filter(this.accounts, (account) => {
              if(account.tags && account.tags.indexOf(this.tagsByName['Passive']._id) == -1 || !account.tags) return account;
            });
      }
   },
   mounted(){
      document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.setUpgradeModal(false) } })
      document.body.classList.add('overflowYHidden');

      //Burada adamın active accountslarını say ona göre engelle
this.allPurchases = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()
this.allPurchases = this.allPurchases.concat(this.getSubscriptions)
let allActiveAccounts = _.filter(this.accounts, (a) => {
  if(a.tags && !a.tags.includes(this.tagsByName['Passive']._id)){
    return a
  }
})
let totalChannelLimit = _.sumBy(this.allPurchases, 'channelLimit')
this.allActiveAccounts = allActiveAccounts.length;
this.totalLimits2 = totalChannelLimit
  if(allActiveAccounts.length > totalChannelLimit){
     this.limitexceed = true;
     setInterval(() => {
       $('#allert').transition('pulse');
     }, 1500)
  }

   },
   created(){


      let purchases = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()
      purchases = purchases.concat(this.getSubscriptions)

      let ltdPackages = _.filter(purchases, (purchase) =>{
         if(purchase.package && (purchase.package == 'AppSumo' || purchase.package == 'Porthos'  || purchase.package == 'Aramis')) {
            return true
         }
      })

      if(ltdPackages.length) this.isLtd = true


      
      let mainPlans = _(_.filter(this.getPlans, (plan) => (plan.metadata.name == 'Starter' || plan.metadata.name == 'Growth')).map((plan) => {
            plan.metadata.price = '$' + ((plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)) + '/' + 'mo'
            console.log(plan.metadata.price)
            if(plan.metadata.name == 'Business'){
               plan.metadata.desc = 'For the Business working internally as a team or solo enterpreneurs.'
            }
            if(plan.metadata.name == 'Agency'){
               plan.metadata.desc = 'For the Agencies which have multiple clients. Have a white-label option soon <a class="nn-link" target="_blank" href="https://juphy.canny.io/feature-requests/p/white-labeling-like-acme-companyjuphycom-for-agencies">learn more.</a>'
            }
            return plan
         })).orderBy(['amount'], ['asc']).value()

         let upgradeChannels = _(_.filter(this.getPlans, { metadata: { name: 'Extra Channel +10' } })).map(plan => {
            plan.metadata.price = (plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)
            return plan;
         }).value()

         let whiteLabelUnlimited = _(_.filter(this.getPlans, { metadata: { identity: 'white_label_unlimited' } })).map(plan => {
            plan.metadata.price = (plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)
            return plan;
         }).value()

         let whiteLabelPerWorkspace = _(_.filter(this.getPlans, { metadata: { identity: 'white_label_per_workspace' } })).map(plan => {
            plan.metadata.price = (plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)
            return plan;
         }).value()

      this.plans = {
         an: _.filter(mainPlans, {interval: 'year'}),
         mo: _.filter(mainPlans, {interval: 'month'}),
         upgradeChannels: {
            an: _.filter(upgradeChannels, {interval: 'year'}),
            mo: _.filter(upgradeChannels, {interval: 'month'})
         },
         addons: {
            whiteLabel: {
               unlimited: {
                  mo: _.filter(whiteLabelUnlimited, {interval: 'month'})
               },
               perWorkspace: {
                  mo: _.filter(whiteLabelPerWorkspace, {interval: 'month'})
               }
            }
         }
      }



      this.features = [{
         id: 1,
         name: 'Channels',
         data: [
            'Up to 5',
            'Up to 12'
            ]
      },/* {
         id: 2,
         name: 'Users',
         data: [
            'Unlimited',
            'Unlimited'
            ]
      }, */{
         id: 3,
         name: 'Data History',
         data: [
            '6 Months',
            'Unlimited'
            ]
      },{
         id: 4,
         name: 'Team Collaboration',
         //desc: 'Create seperated external teams to manage your clients. Agency specific feature.',
         data: [
            '<i class="check icon"></i>',
            '<i class="check icon"></i>'
            ]
      },{
         id: 5,
         name: 'All Core Features',
         data: [
            '<i class="check icon"></i>',
            '<i class="check icon"></i>'
            ]
      },{
         id: 6,
         name: 'Ads Comments',
         data: [
            '<i class="x icon"></i>',
            '<i class="check icon"></i>'
            ]
      }]
   }
}

</script>

<template>
<div class="modalWrapper">
<div class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">

<!-- <div  class="ui grid centered stackable">
   <div class="fifteen wide column" >
      <div style="padding: 0;" @click="closeModal()"  class="ui basic segment right aligned">
      <a style="background: rgba(0,0,0,0.6); position:relative; z-index:9999" class="ui black mini button">Close [ESC]</a>
      </div>
   </div>
</div> -->

   <div class="ui grid">
   <div style="background: #f1f1f1; border-radius: 0.5rem;" class="seven wide column centered">

<div class="ui basic segment">
   <div class="ui button">Upgrade</div>
         <router-link v-if="getRole.name == 'Admin'" v-show="!getWhiteLabel"  to="/upgrade">
          Upgrade
        </router-link>
</div>

<!--       <div v-if="limitexceed" class="ui basic huge center aligned segment">
         <p id="allert">
            😱 Your max channels limit is  <b style="color: #ff0000;">{{totalLimits2}}</b> but you have <b style="color: #ff0000;">{{allActiveAccounts}}</b> active channels, you have to upgrade your plan.
         </p>
      </div>
   <div class="ui basic segment">
      <table class="ui very basic celled large padded table">
         <thead>
           <tr>
         <th style="text-align: center;">
            <div class="ui small buttons">
               <button @click="activePeriod = 'mo'" :class="(activePeriod == 'mo') ? 'active':''" class="ui button">
                  Monthly
               </button>
               <button @click="activePeriod = 'an'" :class="(activePeriod == 'an') ? 'active':''" class="ui button">
                  Yearly [ 20% Off ]
               </button>
            </div>
         </th>
         <th v-for="plan in plans[activePeriod]" :key="plan.id">
            <span style="color:royalblue; display: block; font-size: 22px;">{{plan.metadata.name}}</span>
            <span v-html="plan.metadata.desc" style="color: #222222; display: block; font-weight: 400; margin-top:10px;">
               
            </span>
            <span style="color: #222222; display: block; font-size: 30px; font-weight: 400; margin-top:10px;">
               {{plan.metadata.price}}
            </span>
         </th>
         </tr></thead>
         <tbody>
            <tr v-for="feature in features" :key="feature.id">

               <td style="display: block;" data-label="Name">
                  <b>{{feature.name}}</b>
                  <span v-if="feature.desc" style="display: block;">
                     {{feature.desc}}
                  </span>
               </td>

               <td v-for="(desc, index) in feature.data" :key="index" data-label="Age">
                  <span v-html="desc"></span>
               </td>
            </tr>
            <tr>
               <td></td>
               <td v-for="plan in plans[activePeriod]" :key="plan.id" data-label="Age">
                  <a href="#" @click="open(plan, 1)" style="background: royalblue; display:block;" class="ui blue button">Upgrade {{plan.name}} Plan</a>
               </td>
            </tr>
         </tbody>
       </table>


   </div> -->
   </div>
   </div>

   </div>
</div>
</template>


<style scoped>

      .modalWrapper {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         z-index: 99999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
      .modalWrapper div {
         z-index: 99999;
      }
      .modal {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         background: rgba(41, 50, 84, 0.738) none repeat scroll 0% 0%; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
</style>





// WEBPACK FOOTER //
// src/components/dashboard/UpgradePlan.vue